/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*
* Price updates on variant change are handled natively by theme.js via the
* data-price-wrapper markup in snippets/product-price.liquid.
*/

/* CASA BELLA language selector: close the dropdown on outside click or Escape */
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-cb-lang] details[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (e) {
    var inside = e.target.closest('[data-cb-lang] details');
    closeAll(inside);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();

/* CASA BELLA product rows (sections/ll-featured-products.liquid): arrows and progress line
   when there are more cards than fit; the row itself scrolls with touch / trackpad. */
(function () {
  function setup(rail) {
    if (rail.hasAttribute('data-ll-rail-ready')) return;
    rail.setAttribute('data-ll-rail-ready', '');
    var track = rail.querySelector('[data-ll-rail-track]');
    var prev = rail.querySelector('[data-ll-rail-prev]');
    var next = rail.querySelector('[data-ll-rail-next]');
    var progress = rail.parentNode.querySelector('[data-ll-rail-progress]');
    var bar = progress && progress.querySelector('span');
    if (!track) return;

    function step() {
      var card = track.querySelector('.ll-card');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 2;
      if (prev) prev.hidden = !scrollable || track.scrollLeft <= 2;
      if (next) next.hidden = !scrollable || track.scrollLeft >= max - 2;
      if (progress) progress.hidden = !scrollable;
      if (bar && scrollable) {
        var size = track.clientWidth / track.scrollWidth;
        bar.style.width = (size * 100) + '%';
        bar.style.transform = 'translateX(' + ((track.scrollLeft / max) * (1 / size - 1) * 100) + '%)';
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-ll-rail]').forEach(setup);
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* CASA BELLA colour dots on product cards (snippets/ll-card-swatches.liquid):
   show that colour's photo and link the card to that variant. */
document.addEventListener('click', function (e) {
  var dot = e.target.closest('[data-ll-swatch]');
  if (dot && dot.closest('.ll-featured')) return; // home rows: dots are not clickable
  if (!dot) return;
  e.preventDefault();
  var card = dot.closest('.ll-card, .product-item');
  if (!card) return;

  card.querySelectorAll('[data-ll-swatch]').forEach(function (d) {
    d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
  });

  // the photo shown: the card's main photo, and on phones the first photo of the swipeable set on top of it
  var src = dot.getAttribute('data-src');
  if (src) {
    var srcset = dot.getAttribute('data-srcset');
    card.querySelectorAll('.ll-card__img img:not(.ll-card__hover), [data-product-image-default] img').forEach(function (img) {
      if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
    });
    cbShowColourSlides(card, dot.getAttribute('title'));
  }

  // hover photo (computer): the next photo of the newly chosen colour, or none
  var frame = card.querySelector('.ll-card__img');
  if (frame) {
    var hover = frame.querySelector('.ll-card__hover');
    var hoverSrc = dot.getAttribute('data-hover');
    if (hoverSrc) {
      if (!hover) {
        hover = document.createElement('img');
        hover.className = 'll-card__hover';
        hover.alt = '';
        hover.setAttribute('aria-hidden', 'true');
        frame.appendChild(hover);
      }
      hover.removeAttribute('data-cb-original');
      hover.setAttribute('src', hoverSrc);
    } else if (hover) {
      hover.remove();
    }
  }

  var url = dot.getAttribute('data-url');
  card.querySelectorAll('.ll-card__link, .product-link').forEach(function (a) {
    if (url) a.setAttribute('href', url);
  });

  var quick = card.querySelector('[data-cb-quick-view]');
  if (quick) quick.setAttribute('data-variant', dot.getAttribute('data-variant') || '');
});

/* CASA BELLA product gallery arrows (sections/product.liquid): show the previous / next photo. */
document.addEventListener('click', function (e) {
  var arrow = e.target.closest('[data-cb-thumb-prev], [data-cb-thumb-next]');
  if (!arrow) return;
  var holder = arrow.parentNode.querySelector('[data-thumbs-slider]');
  if (!holder) return;
  var thumbs = Array.prototype.slice.call(holder.querySelectorAll('[data-thumb-item]'));
  var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
  if (current < 0) current = 0;
  var step = arrow.hasAttribute('data-cb-thumb-next') ? 1 : -1;
  var target = thumbs[(current + step + thumbs.length) % thumbs.length];
  var link = target && target.querySelector('[data-thumb-link]');
  if (link) link.click();
  if (target) holder.scrollTo({ left: target.offsetLeft - holder.clientWidth / 2 + target.clientWidth / 2, behavior: 'smooth' });
});

/* CASA BELLA product photos on phones: thin progress segments under the swipeable gallery. */
(function () {
  function setup(slides) {
    if (slides.hasAttribute('data-cb-progress')) return;
    var items = slides.querySelectorAll('.product__slide');
    if (items.length < 2) return;
    slides.setAttribute('data-cb-progress', '');

    var bar = document.createElement('div');
    bar.className = 'cb-gallery-progress';
    bar.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < items.length; i++) bar.appendChild(document.createElement('span'));
    slides.parentNode.insertBefore(bar, slides.nextSibling);
    var segments = bar.children;

    function update() {
      var width = items[0].getBoundingClientRect().width || 1;
      var index = Math.min(items.length - 1, Math.max(0, Math.round(slides.scrollLeft / width)));
      for (var j = 0; j < segments.length; j++) segments[j].classList.toggle('is-active', j === index);
    }

    slides.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('.product__images--mobile-slider .product__slides').forEach(setup);
  }

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* CASA BELLA size dropdown on phones (snippets/product-variant-options.liquid): mirrors the size radios. */
(function () {
  function radiosFor(select) {
    var fieldset = select.closest('.radio__fieldset');
    return fieldset ? Array.prototype.slice.call(fieldset.querySelectorAll('.radio__buttons input[type="radio"]')) : [];
  }

  /* The native list is drawn by the phone (iOS wraps long lines next to its tick), so the shop shows
     its own list: size on the left, note on the right, one line each. The <select> keeps the state. */
  function build(select) {
    var wrap = select.parentNode;
    if (wrap.querySelector('.cb-size-select__button')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cb-size-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    var list = document.createElement('ul');
    list.className = 'cb-size-select__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    wrap.appendChild(button);
    wrap.appendChild(list);
    wrap.classList.add('is-custom');

    function close() {
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }
    button.addEventListener('click', function () {
      var open = list.hidden;
      list.hidden = !open;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var current = list.querySelector('[aria-selected="true"]') || list.querySelector('[role="option"]:not([aria-disabled="true"])');
        if (current) current.focus();
      }
    });
    list.addEventListener('click', function (e) {
      var item = e.target.closest('[role="option"]');
      if (!item || item.getAttribute('aria-disabled') === 'true') return;
      select.value = item.getAttribute('data-value');
      select.dispatchEvent(new Event('change', { bubbles: true }));
      close();
      button.focus();
    });
    list.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(list.querySelectorAll('[role="option"]:not([aria-disabled="true"])'));
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && items.length) { e.preventDefault(); items[Math.min(items.length - 1, i + 1)].focus(); }
      if (e.key === 'ArrowUp' && items.length) { e.preventDefault(); items[Math.max(0, i - 1)].focus(); }
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (document.activeElement.click) document.activeElement.click(); }
      if (e.key === 'Escape') { close(); button.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  }

  function render(select) {
    var wrap = select.parentNode;
    var button = wrap.querySelector('.cb-size-select__button');
    var list = wrap.querySelector('.cb-size-select__list');
    if (!button || !list) return;
    var soldOut = select.getAttribute('data-sold-out') || 'Esgotado';
    var html = '';
    var label = '';
    Array.prototype.forEach.call(select.options, function (option) {
      var note = option.getAttribute('data-note') || '';
      if (!option.value) {
        if (!select.value) label = '<span class="cb-size-select__placeholder">' + escapeText(option.textContent) + '</span>';
        return;
      }
      var selected = option.value === select.value;
      if (selected) label = '<span class="cb-size-select__size">' + escapeText(option.value) + '</span>' + (note ? '<span class="cb-size-select__note">' + escapeText(note) + '</span>' : '');
      html += '<li role="option" tabindex="-1" data-value="' + escapeText(option.value) + '" aria-selected="' + selected + '"' + (option.disabled ? ' aria-disabled="true"' : '') + '>' +
        '<span class="cb-size-select__size">' + escapeText(option.value) + '</span>' +
        (option.disabled ? '<span class="cb-size-select__out">' + escapeText(soldOut) + '</span>' : (note ? '<span class="cb-size-select__note">' + escapeText(note) + '</span>' : '')) +
        '</li>';
    });
    list.innerHTML = html;
    button.innerHTML = label + '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M1 1l5 5 5-5"/></svg>';
    button.setAttribute('aria-label', select.getAttribute('aria-label') || '');
  }

  function escapeText(value) {
    return String(value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function refresh(select) {
    build(select);
    radiosFor(select).forEach(function (radio) {
      var option = Array.prototype.filter.call(select.options, function (o) { return o.value === radio.value; })[0];
      if (!option) return;
      var out = radio.disabled || radio.classList.contains('sold-out') || radio.classList.contains('unavailable');
      option.disabled = out;
      var note = option.getAttribute('data-note');
      option.textContent = radio.value + (note ? ' – ' + note : '') + (out ? ' · ' + (select.getAttribute('data-sold-out') || 'Esgotado') : '');
      // The placeholder stays until the shopper picks a size herself
      if (radio.checked && select.hasAttribute('data-chosen')) select.value = radio.value;
      // Desktop: show the note of the chosen size under the size letters
      var line = select.closest('.radio__fieldset').querySelector('[data-cb-size-note-line]');
      if (line && radio.checked) {
        line.textContent = note || '';
        line.hidden = !note;
      }
    });
    render(select);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cb-size-select]')) {
      var value = e.target.value;
      e.target.setAttribute('data-chosen', '');
      e.target.parentNode.classList.remove('is-required');
      radiosFor(e.target).forEach(function (radio) {
        if (radio.value === value && !radio.checked) radio.click();
      });
      render(e.target);
      return;
    }
    if (e.target.matches('[data-single-option-selector]')) {
      // Let the theme mark sold-out options first
      setTimeout(function () {
        document.querySelectorAll('[data-cb-size-select]').forEach(refresh);
      }, 60);
    }
  });

  // A size is already chosen when the page opens (M when available, else the middle available size);
  // the shopper changes it if she wants. Done once per page, never over a size she picked.
  function preselect(select) {
    if (select.value || select.hasAttribute('data-cb-auto')) return;
    select.setAttribute('data-cb-auto', '');
    var opts = Array.prototype.filter.call(select.options, function (o) { return o.value && !o.disabled; });
    if (!opts.length) return;
    var pick = opts.filter(function (o) { return o.value.trim().toUpperCase() === 'M'; })[0] || opts[Math.floor((opts.length - 1) / 2)];
    select.value = pick.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function init() {
    document.querySelectorAll('[data-cb-size-select]').forEach(function (select) {
      refresh(select);
      if (select.closest('.cb-qv')) return;
      preselect(select);
    });
  }
  document.addEventListener('cb:refresh', function (e) { if (e.target.matches && e.target.matches('[data-cb-size-select]')) refresh(e.target); }, true);

  // On phones no size is preselected: adding to cart first asks for one.
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-add-to-cart], [data-cb-buy-now]');
    if (!button) return;
    var scope = button.closest('[data-section-id]') || document;
    var select = scope.querySelector('[data-cb-size-select]');
    if (!select || select.parentNode.offsetParent === null || select.value) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    select.parentNode.classList.add('is-required');
    var custom = select.parentNode.querySelector('.cb-size-select__button');
    (custom || select).focus();
  }, true);

  document.addEventListener('theme:variant:change', function () { setTimeout(init, 60); });
  window.addEventListener('load', function () { setTimeout(init, 200); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* CASA BELLA product photos: every garment the same size, centred, on exactly the same background.
   The photo is redrawn by the page itself: its garment is found against the photo's own background
   (read from the corners), scaled and centred in the card, and the background is turned into the card
   colour pixel by pixel. The card then shows that finished picture, so the result does not depend on
   CSS blending (which iPhone Safari ignores). Add ?cbdebug=1 to a URL to see each photo's status. */
(function () {
  var FRAMES = '.ll-card__img, .product-item__image:not(.cb-soon__image), .cb-related__img, .cb-qv__slide, .cb-qv__thumb, .cart__item__image, .cb-upsell__img, .cb-soon__slide';
  // share of the frame covered by the garment, and the most height / width it may take
  var CARD = { area: 0.38, height: 0.72, width: 0.92 };   // cards: long dresses in line with coats
  var LARGE = { area: 0.5, height: 0.86, width: 0.9 };    // quick view photos
  var COMPACT = { area: 0.28, height: 0.6, width: 0.8 };
  // photos of a person wearing the piece are not redrawn (see bake)
  var MODEL_WORDS = /\bmodelo\b/i;
  function isModel(box, img) {
    if (MODEL_WORDS.test(img.getAttribute('alt') || '')) return true;
    // photos marked "modelo" in their alt text in the admin (file names listed on the card by the theme)
    var holder = img.closest('[data-cb-models]');
    if (holder) {
      var file = (img.getAttribute('data-cb-original') || img.currentSrc || img.src || '').split('?')[0].split('/').pop();
      if (file && holder.getAttribute('data-cb-models').indexOf('|' + file + '|') !== -1) return true;
    }
    // only photos marked "modelo" count: guessing from the shape caught product photos too
    return false;
  }  // 'Em breve' / 'Esgotado' pieces (vests, short pieces) next to the coats
  var BACKGROUND = [248, 246, 242]; // the card colour (custom.css)
  var DEBUG = /[?&]cbdebug=1/.test(window.location.search);

  function sized(src, width, plain) {
    var url;
    try {
      url = new URL(src, window.location.href);
      url.searchParams.set('width', String(width));
      url.searchParams.set('cb-fit', plain ? '2' : '1');
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  // Load a copy of the photo the page may read. Safari can refuse the CORS copy; the shop's own
  // images can then be read without it.
  function load(src, width, done) {
    var tries = [false, true];
    (function next() {
      if (!tries.length) return done(null, 'blocked');
      var plain = tries.shift();
      var probe = new Image();
      if (!plain) probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = c.height = 1;
          c.getContext('2d').drawImage(probe, 0, 0, 1, 1);
          c.getContext('2d').getImageData(0, 0, 1, 1);
          done(probe);
        } catch (e) {
          next();
        }
      };
      probe.onerror = next;
      probe.src = sized(src, width, plain);
    })();
  }

  function measure(probe) {
    var w = 120;
    var h = Math.max(1, Math.round(w * probe.naturalHeight / probe.naturalWidth));
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(probe, 0, 0, w, h);
    var data = ctx.getImageData(0, 0, w, h).data;
    var px = function (x, y) { var i = (y * w + x) * 4; return [data[i], data[i + 1], data[i + 2]]; };
    var corners = [px(1, 1), px(w - 2, 1), px(1, h - 2), px(w - 2, h - 2)];
    var bg = [0, 1, 2].map(function (c) { return Math.round(corners.reduce(function (s, p) { return s + p[c]; }, 0) / 4); });
    function outline(limit) {
    // clearly different pixels per row and column; soft floor shadows and noise stay below the threshold
    var rows = new Array(h).fill(0), cols = new Array(w).fill(0), area = 0;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var p = px(x, y);
        if (Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) > limit) {
          rows[y]++;
          cols[x]++;
          area++;
        }
      }
    }
    var span = function (counts, min) {
      var first = -1, last = -1;
      for (var i = 0; i < counts.length; i++) {
        if (counts[i] >= min) { if (first < 0) first = i; last = i; }
      }
      return [first, last];
    };
    var ys = span(rows, Math.max(2, w * 0.03)), xs = span(cols, Math.max(2, h * 0.02));
      return { rows: rows, cols: cols, area: area, ys: ys, xs: xs };
    }
    var o = outline(66);
    var rows = o.rows, cols = o.cols, area = o.area, ys = o.ys, xs = o.xs;
    if (xs[0] < 0 || ys[0] < 0) return null;
    // brightness of the garment's middle: pale garments (white fur) are close to the background
    var lum = function (q) { return q[0] * 0.3 + q[1] * 0.59 + q[2] * 0.11; };
    var sum = 0, count = 0;
    for (var yy = Math.round(ys[0] + (ys[1] - ys[0]) * 0.3); yy <= ys[0] + (ys[1] - ys[0]) * 0.7; yy++) {
      for (var xx = Math.round(xs[0] + (xs[1] - xs[0]) * 0.3); xx <= xs[0] + (xs[1] - xs[0]) * 0.7; xx++) {
        sum += lum(px(xx, yy));
        count++;
      }
    }
    var pale = count > 0 && sum / count > lum(bg) - 100;
    if (pale) {
      // light garment, close to the background: a finer outline so all of it is found (not cut off)
      o = outline(40);
      // accepted only if it stays clear of the photo's edges (else it caught the background's uneven light)
      var clear = o.xs[0] > w * 0.03 && o.xs[1] < w * 0.97 && o.ys[0] > h * 0.02 && o.ys[1] < h * 0.98;
      if (o.xs[0] >= 0 && o.ys[0] >= 0 && clear) { rows = o.rows; cols = o.cols; area = o.area; ys = o.ys; xs = o.xs; }
    }
    return {
      pale: pale,
      bg: bg,
      x: xs[0] / w, y: ys[0] / h,
      w: (xs[1] - xs[0] + 1) / w, h: (ys[1] - ys[0] + 1) / h,
      fill: area / ((xs[1] - xs[0] + 1) * (ys[1] - ys[0] + 1)),
      ratio: probe.naturalWidth / probe.naturalHeight
    };
  }

  // Draw the finished picture for a frame of fw x fh CSS pixels
  function render(source, box, fw, fh, fill) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = Math.round(fw * dpr), H = Math.round(fh * dpr);
    var iw = W, ih = W / box.ratio;
    if (ih > H) { ih = H; iw = H * box.ratio; }
    var gw = box.w * iw, gh = box.h * ih;
    var byArea = Math.sqrt((fill.area * W * H) / (gw * gh * Math.max(0.35, box.fill || 0.6)));
    var scale = Math.min(byArea, (fill.height * H) / gh, (fill.width * W) / gw);
    var dw = iw * scale, dh = ih * scale;
    // garment centre on the frame centre
    var dx = W / 2 - (box.x + box.w / 2) * dw;
    var dy = H / 2 - (box.y + box.h / 2) * dh;

    var canvas = document.createElement('canvas');
    canvas.width = W;
    canvas.height = H;
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(source, dx, dy, dw, dh);

    // The photo's background becomes exactly the card colour; the garment keeps its own colours.
    // The background is found by spreading from the picture's edges over smooth, background-coloured
    // pixels; fur and fabric have texture, so pale garments (white fur) stop the spread and stay as shot.
    var T = BACKGROUND;
    var shift = [0, 1, 2].map(function (c) { return T[c] - box.bg[c]; });
    var img = ctx.getImageData(0, 0, W, H);
    var d = img.data;
    var n = W * H;
    // the garment's own outline in this picture (its floor shadow lies outside it)
    var gx0 = dx + box.x * dw, gx1 = dx + (box.x + box.w) * dw;
    var gy0 = dy + box.y * dh, gy1 = dy + (box.y + box.h) * dh - dh * 0.01;
    if (box.pale) {
      // Light garment (white, cream, beige): the photo stays exactly as shot, on its own background;
      // only its size and centring match the other cards. The card around it takes that background.
      ctx.globalCompositeOperation = 'destination-over';
      var nearCard = Math.abs(box.bg[0] - T[0]) + Math.abs(box.bg[1] - T[1]) + Math.abs(box.bg[2] - T[2]) < 1;
      ctx.fillStyle = 'rgb(' + (nearCard ? T : box.bg).join(',') + ')';
      ctx.fillRect(0, 0, W, H);
      return canvas;
    }
    var mask = new Uint8Array(n);   // 1 = background
    var queue = new Int32Array(n);
    var head = 0, tail = 0;
    function near(i) {
      var o = i * 4;
      if (!d[o + 3]) return true;   // outside the photo
      return Math.abs(d[o] + shift[0] - T[0]) + Math.abs(d[o + 1] + shift[1] - T[1]) + Math.abs(d[o + 2] + shift[2] - T[2]) < 46;
    }
    function smooth(i, j) {
      var o = i * 4, q = j * 4;
      if (!d[o + 3] || !d[q + 3]) return true;
      return Math.abs(d[o] - d[q]) + Math.abs(d[o + 1] - d[q + 1]) + Math.abs(d[o + 2] - d[q + 2]) < 14;
    }
    function seed(i) { if (!mask[i] && near(i)) { mask[i] = 1; queue[tail++] = i; } }
    for (var x = 0; x < W; x++) { seed(x); seed((H - 1) * W + x); }
    for (var y = 0; y < H; y++) { seed(y * W); seed(y * W + W - 1); }
    while (head < tail) {
      var i = queue[head++], px = i % W;
      var around = [px > 0 ? i - 1 : -1, px < W - 1 ? i + 1 : -1, i - W, i + W];
      for (var a = 0; a < 4; a++) {
        var j = around[a];
        if (j < 0 || j >= n || mask[j]) continue;
        if (near(j) && smooth(i, j)) { mask[j] = 1; queue[tail++] = j; }
      }
    }
    // left-over background patches outside the garment (e.g. a pale floor shadow the spread could not reach)
    for (var r = 0; r < n; r++) {
      if (mask[r]) continue;
      var rx = r % W, ry = (r / W) | 0;
      if ((rx < gx0 || rx > gx1 || ry < gy0 || ry > gy1) && near(r)) mask[r] = 1;
      else if (ry > gy1 - (gy1 - gy0) * 0.04 && near(r)) mask[r] = 1;
    }
    for (var p = 0; p < n; p++) {
      var o = p * 4;
      if (mask[p]) {
        d[o] = T[0]; d[o + 1] = T[1]; d[o + 2] = T[2]; d[o + 3] = 255;
        continue;
      }
      // garment: the same small tone shift as the background, nothing brighter; half-way at its edge
      var edge = (p % W > 0 && mask[p - 1]) || (p % W < W - 1 && mask[p + 1]) || (p >= W && mask[p - W]) || (p < n - W && mask[p + W]);
      for (var c = 0; c < 3; c++) {
        var v = d[o + c] + shift[c];
        if (edge) v = (v + T[c]) / 2;
        d[o + c] = v < 0 ? 0 : v > 255 ? 255 : v;
      }
    }
    ctx.putImageData(img, 0, 0);
    // card colour around the photo
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = 'rgb(' + BACKGROUND.join(',') + ')';
    ctx.fillRect(0, 0, W, H);
    return canvas;
  }

  function status(frame, text) {
    if (!DEBUG) return;
    var tag = frame.querySelector('.cb-fit-debug');
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'cb-fit-debug';
      tag.style.cssText = 'position:absolute;left:4px;bottom:4px;z-index:9;padding:2px 5px;background:#000;color:#fff;font:10px/1.3 monospace';
      frame.appendChild(tag);
    }
    tag.textContent = text;
  }

  var sources = {};

  function bake(img) {
    var frame = img.closest(FRAMES);
    if (!frame) return;
    var src = img.getAttribute('data-cb-original') || img.currentSrc || img.src;
    if (!src || /^(blob|data):/.test(src)) return;
    var fw = frame.clientWidth, fh = frame.clientHeight;
    if (!fw || !fh) return;
    // photos marked as a model photo: never touched, shown exactly as uploaded
    if (isModel({ h: 0, w: 1, ratio: 1, fill: 1 }, img)) {
      img.setAttribute('data-cb-model', '');
      return;
    }
    var key = src.replace(/[?&]width=\d+/, '');
    var job = key + '|' + fw + 'x' + fh;
    if (img.getAttribute('data-cb-fit-job') === job) return;
    img.setAttribute('data-cb-fit-job', job);
    status(frame, 'loading');

    function finish(entry) {
      if (!entry.source || !entry.box) {
        status(frame, 'fit: ' + (entry.reason || 'no garment found'));
        return;
      }
      if (img.getAttribute('data-cb-fit-job') !== job) return;
      // photo of a model: left as it was taken (own background, filling the card), never redrawn
      if (isModel(entry.box, img)) {
        img.setAttribute('data-cb-model', '');
        status(frame, 'fit: model photo, untouched');
        return;
      }
      img.removeAttribute('data-cb-model');
      try {
        var canvas = render(entry.source, entry.box, fw, fh, frame.matches('.cb-qv__slide') ? LARGE : frame.matches('.cb-soon__slide') ? COMPACT : CARD);
        var apply = function (url) {
          if (img.getAttribute('data-cb-fit-job') !== job) return;
          if (!img.hasAttribute('data-cb-original')) img.setAttribute('data-cb-original', src);
          if (img._cbUrl) URL.revokeObjectURL(img._cbUrl);
          img._cbUrl = url.indexOf('blob:') === 0 ? url : null;
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.removeAttribute('loading');
          img.setAttribute('data-cb-baked', '');
          img.src = url;
          img.style.opacity = '';
          frame.style.backgroundColor = 'rgb(' + BACKGROUND.join(',') + ')';
          status(frame, 'fit: ok');
        };
        if (canvas.toBlob) canvas.toBlob(function (blob) { apply(blob ? URL.createObjectURL(blob) : canvas.toDataURL('image/jpeg', 0.92)); }, 'image/jpeg', 0.92);
        else apply(canvas.toDataURL('image/jpeg', 0.92));
      } catch (e) {
        status(frame, 'fit: ' + e.name);
      }
    }

    var entry = sources[key];
    if (entry && entry.done) return finish(entry);
    if (entry) return entry.waiting.push(finish);
    entry = sources[key] = { waiting: [finish] };
    load(src, 800, function (probe, reason) {
      entry.done = true;
      entry.source = probe;
      entry.reason = reason;
      try {
        entry.box = probe ? measure(probe) : null;
      } catch (e) {
        entry.reason = e.name;
      }
      entry.waiting.forEach(function (fn) { fn(entry); });
      entry.waiting = [];
    });
  }

  function watch(img) {
    if (img.hasAttribute('data-cb-fit-watch')) return;
    img.setAttribute('data-cb-fit-watch', '');
    img.addEventListener('load', function () {
      // a new photo (e.g. a colour dot): forget the previous one and redraw
      var current = img.currentSrc || img.src;
      if (/^(blob|data):/.test(current)) return;
      img.removeAttribute('data-cb-original');
      img.removeAttribute('data-cb-baked');
      // hide the raw photo for the instant it takes to redraw it (no flash of the original)
      if (!img.hasAttribute('data-cb-fit-job')) return; // not reached yet: the observer will handle it
      img.style.opacity = '0';
      setTimeout(function () { img.style.opacity = ''; }, 1500);
      bake(img);
    });
    // only photos on (or near) the screen are redrawn; the rest wait until they are scrolled or swiped to
    if (io) io.observe(img); else if (img.complete && img.naturalWidth) bake(img);
  }
  var io = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var img = e.target;
      if (img.complete && img.naturalWidth) bake(img);
      else img.addEventListener('load', function () { bake(img); }, { once: true });
    });
  }, { rootMargin: '300px 300px' }) : null;

  function scan(root) {
    // every photo of the card: on phones the theme shows a swipeable set of photos over the first one
    (root || document).querySelectorAll(FRAMES).forEach(function (frame) {
      if (frame.classList.contains('ll-card__img--more')) return;
      frame.querySelectorAll('img').forEach(watch);
    });
  }

  var resizeTimer, lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    // phones fire resize when the address bar moves; only a real width change needs new pictures
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('img[data-cb-fit-watch]').forEach(bake);
    }, 200);
  });
  // cards added later (rows that load more, quick view, editor)
  if (window.MutationObserver) {
    // batched: one quick look for new cards after DOM changes settle, not one per change
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(); }, 250);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  window.CBFitImages = scan;
})();

/* CASA BELLA catalogue cards: the swipeable photos show only the chosen colour (slides carry data-cb-color) */
function cbShowColourSlides(card, colour) {
  var slider = card.querySelector('[data-hover-slider]');
  if (!slider) return;
  // computer (hover carousel): the theme's own behaviour, untouched
  if (document.documentElement.classList.contains('no-touch')) return;
  // phones (swipe): only the chosen colour's photos
  var slides = slider.querySelectorAll('[data-cb-color]');
  var any = Array.prototype.some.call(slides, function (s) { return s.getAttribute('data-cb-color') === colour; });
  slides.forEach(function (s) { s.classList.toggle('cb-hidden', any && s.getAttribute('data-cb-color') !== colour); });
  slider.scrollLeft = 0;
  // the line under the photo: one segment per photo of this colour
  var holder = slider.closest('hover-images') || slider.parentNode;
  var count = slider.querySelectorAll('[data-cb-color]:not(.cb-hidden)').length || 1;
  holder.style.setProperty('--cb-count', count);
  holder.style.setProperty('--cb-index', 0);
  holder.classList.toggle('cb-single', count < 2);
  if (!slider._cbScroll) {
    slider._cbScroll = true;
    // once per frame, and only when the photo number changes (keeps the swipe smooth)
    var queued = false, last = -1;
    slider.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        var i = Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth));
        if (i !== last) { last = i; holder.style.setProperty('--cb-index', i); }
      });
    }, { passive: true });
  }
}
(function () {
  function init(root) {
    (root || document).querySelectorAll('.product-item').forEach(function (card) {
      var dot = card.querySelector('[data-ll-swatch][aria-pressed="true"]') || card.querySelector('[data-ll-swatch]');
      if (dot) cbShowColourSlides(card, dot.getAttribute('title'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* CASA BELLA extra sold-out sizes / colours (snippets/product-variant-options.liquid):
   sizes go in size order (XS before S…), crossed colour dots take the size of the real dots */
(function () {
  var ORDER = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'TU'];
  function rank(v) {
    var k = String(v).trim().toUpperCase();
    var i = ORDER.indexOf(k);
    if (i >= 0) return i;
    var n = parseFloat(k);
    return isNaN(n) ? 999 : 100 + n;
  }
  function tidy(root) {
    (root || document).querySelectorAll('[data-cb-size-select]').forEach(function (select) {
      if (!select.querySelector('[data-cb-extra]')) return;
      var opts = Array.prototype.slice.call(select.options).filter(function (o) { return o.value; });
      opts.sort(function (a, b) { return rank(a.value) - rank(b.value); }).forEach(function (o) { select.appendChild(o); });
      select.dispatchEvent(new Event('cb:refresh'));
    });
    (root || document).querySelectorAll('.cb-swatch-extra').forEach(function (dot) {
      var real = dot.parentNode.querySelector('.swatch__button, .swatches');
      if (!real) return;
      // the visible round dot: the smallest square element inside the real swatch
      var best = null;
      [real].concat(Array.prototype.slice.call(real.querySelectorAll('*'))).forEach(function (el) {
        var b = el.getBoundingClientRect();
        if (b.width > 12 && Math.abs(b.width - b.height) < 2 && (!best || b.width < best.width)) best = b;
      });
      if (!best) return;
      var outer = real.getBoundingClientRect();
      dot.style.width = dot.style.height = best.width + 'px';
      dot.style.margin = '0 ' + ((outer.width - best.width) / 2) + 'px';
      dot.style.transform = '';
      // line it up with the real dots' centre
      var d = dot.getBoundingClientRect();
      dot.style.transform = 'translateY(' + ((best.top + best.height / 2) - (d.top + d.height / 2)) + 'px)';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tidy(); }); else tidy();
  window.addEventListener('load', function () { tidy(); });
})();



/* CASA BELLA customer badge: keep the line whole by shrinking the text until it fits (minimum 10px) */
(function () {
  function fit() {
    document.querySelectorAll('.cb-proof__text').forEach(function (el) {
      el.style.fontSize = '';
      var size = parseFloat(getComputedStyle(el).fontSize) || 16;
      while (el.scrollWidth > el.clientWidth + 1 && size > 10) {
        size -= 0.5;
        el.style.fontSize = size + 'px';
      }
    });
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('load', fit);
  window.addEventListener('pageshow', function () { requestAnimationFrame(fit); });
  setTimeout(fit, 600);
  setTimeout(fit, 1600);
})();

/* Price style A: keep the inline −% in sync with theme's [data-price-off] on variant change */
(function () {
  function sync(wrap) {
    var pct = wrap.querySelector('[data-cb-pct]'), off = wrap.querySelector('[data-price-off]');
    var amt = wrap.querySelector('[data-price-off-amount]');
    if (!pct || !off || !amt) return;
    var t = (amt.textContent || '').trim(), hide = off.classList.contains('hidden') || !t;
    pct.textContent = hide ? '' : '−' + t.replace(/^[−-]/, '');
    pct.classList.toggle('hidden', hide);
  }
  function init() {
    document.querySelectorAll('.cb-price-a').forEach(function (w) {
      if (w.dataset.cbPctInit) return; w.dataset.cbPctInit = '1';
      var off = w.querySelector('[data-price-off]');
      if (off) new MutationObserver(function () { sync(w); }).observe(off, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // the cart totals are re-rendered after every change
  new MutationObserver(function () { if (document.querySelector('[data-cb-bnpl]:not([data-cb-init])')) init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Gift wrap is only offered in the cart: hide any card that links to it elsewhere (search, sliders, recommendations) */
(function () {
  var SEL = 'a[href*="/products/embalagem-especial-para-oferta"]';
  function hide() {
    document.querySelectorAll(SEL).forEach(function (a) {
      if (a.closest('#cart-drawer, .cart, .drawer--cart, .cb-gift')) return;
      var card = a.closest('li, .grid-item, .product-item, .ll-card, .cb-related__card, [class*="search__result"], [class*="card"]');
      if (card) card.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hide); else hide();
  new MutationObserver(function () { if (document.querySelector(SEL)) hide(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Scalapay note: follow the price when the variant changes */
(function () {
  function cents(t) { var n = String(t || '').replace(/[^\d,.\s]/g, '').trim().replace(/\s/g, ''); if (!n) return NaN; n = n.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'); return Math.round(parseFloat(n) * 100); }
  function fmt(c, sample) { var v = (c / 100).toFixed(2); var comma = /,\d{2}/.test(sample); if (comma) v = v.replace('.', ','); return /^\s*€/.test(sample) ? '€' + v : v + ' €'; }
  function init() {
    document.querySelectorAll('[data-cb-bnpl]').forEach(function (note) {
      if (note.dataset.cbInit) return; note.dataset.cbInit = '1';
      var src = note.getAttribute('data-cb-bnpl-src');
      var block = note.closest('.product__block') || note.parentNode;
      var price = src ? (note.parentNode.querySelector(src) || document.querySelector(src)) : block.querySelector('[data-product-price]');
      var amt = note.querySelector('[data-cb-bnpl-amount]');
      if (!price || !amt) return;
      var min = parseInt(note.getAttribute('data-min'), 10) || 0;
      var sample = amt.textContent;
      var update = function () {
        var c = cents(price.textContent);
        if (isNaN(c) || c <= 0 || c < min) { note.hidden = true; return; }
        note.hidden = false;
        amt.textContent = fmt(Math.ceil(c / 3), sample);
      };
      new MutationObserver(update).observe(price, { childList: true, characterData: true, subtree: true });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
